(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["help-center"] && !Shopify.designMode) return;
  try {
    
    var helpButton = document.querySelector(".rotated")
    var helpModal = document.querySelector(".help-modal")
    var closeButton = document.getElementById("close")
  console.log("helpButton",helpButton )
  console.log("helpModal",helpModal )
  console.log("closeButton",helpModal )
  
    helpButton.addEventListener("click", ()=>{
      console.log("clicked button")
       // hide the button
      helpButton.classList.remove("displayOnTheDomTest")
      helpButton.classList.add("removeFromDomTest")

      // show the modal
      helpModal.classList.remove("removeFromDomTest")
      helpModal.classList.add("displayOnTheDomTest")
    })  
 
    closeButton.addEventListener("click", ()=>{
      // show the button
console.log("show button")
      helpButton.classList.remove("removeFromDomTest")
      helpButton.classList.add("displayOnTheDomTest")

      // hide the modal
      console.log("hide button")
      helpModal.classList.add("removeFromDomTest")
      helpModal.classList.remove("displayOnTheDomTest")
    })
  
  

  } catch(e) { console.error(e); }
})();
})();
